<template>
  <!-- <vuetable ref="vuetable" :api-mode="false" :data="jobs" :fields="fields"></vuetable> -->

  <section>
    <div class="controls-wrap">
      <!-- Integration Field -->
      <div class="jobs-controls m-3">
        <h6 style="font-weight: 700; font-size: 18px">Pipeline</h6>
        <div class="no-mobile">
          <div class="d-flex">
            <Search @search="doSearch" placeholderText="Search this grid" class="w-50" />

            <button
              type="button"
              class="ml-auto btn btn-success text-nowrap d-none d-sm-block"
              @click="showModal = true"
            >
              Add to Pipeline
              <portal to="add-to-pipeline-modal">
                <CustomMainModal @close="showModal = false" v-show="showModal">
                  <template v-slot:header>
                    <h5>Add to Pipeline</h5>
                  </template>
                  <AddToPipelineBtnModal
                    v-if="showModal"
                    @pipeline-reload="reloadPipelineList"
                    @close="showModal = false"
                  />
                </CustomMainModal>
              </portal>
            </button>

            <portal-target name="add-to-pipeline-modal"></portal-target>

            <div class="d-flex d-block d-sm-none text-right">
              <AddBtn class="mr-auto">Add to Pipeline</AddBtn>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="table-responsive d-none d-sm-block">
      <table class="table table-striped custom-table" style="table-layout: auto">
        <thead class="bg-dark">
          <tr>
            <th nowrap scope="col" style="font-weight: 600">RATING</th>
            <th nowrap scope="col" style="font-weight: 600">POSITION</th>
            <th nowrap scope="col" style="font-weight: 600">EMPLOYER</th>
            <th nowrap scope="col" style="font-weight: 600">LOCATION</th>
            <th nowrap scope="col" style="font-weight: 600">&nbsp;</th>
            <th nowrap scope="col" style="font-weight: 600">&nbsp;</th>
            <th nowrap scope="col" style="font-weight: 600">SOURCE</th>
            <th nowrap scope="col" style="font-weight: 600">UPDATED</th>
            <th nowrap scope="col" style="font-weight: 600">QUALIFICATION</th>
            <th nowrap scope="col" style="font-weight: 600">STAGE</th>
            <th nowrap scope="col" style="font-weight: 600">SEEN</th>
            <th nowrap scope="col" style="font-weight: 600">ACTION</th>
          </tr>
        </thead>
        <tbody>
          <CandidatePipelineTableItem
            v-for="pipeline in getCandidatePipelines"
            :pipeline="pipeline"
            :user="getCandidateById"
            :key="pipeline.pipeline_id"
            @pipeline-deleted="pipelineID => retrieveCandidatePipelines(pipeline.pipeline_id)"
            @pipeline-reload="reloadPipelineList"
            @pipeline-update="reloadPipelineList"
          />
        </tbody>
      </table>
    </div>
    <ErrorList
      class="no-data-message"
      v-show="getCandidatePipelines.length === 0"
      name="noPipelines"
    />

    <!-- Pagination -->
    <div class="d-flex justify-content-between bottom-controls">
      <div class="ml-auto" id="pagination">
        <Pagination
          :currentPage="getCurrentPage"
          :totalPages="getTotalPages"
          @nextPage="nextPage"
          @prevPage="previousPage"
          @keyup="keymonitor"
          @selectPageByNumber="setPageBynumber"
          @firstPage="setToFirstPage"
          @lastPage="setToLastPage"
        />
      </div>
    </div>
    <!-- End Pagination -->

    <Spinner :isLoading="isLoading" />
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import AddBtn from '../common/TableControlsAddBtn';
import CustomMainModal from '@/components/Modals/CustomMainModal';
import AddToPipelineBtnModal from './AddToPipelineBtnModal';
import Search from '@/components/common/Search/Search';
import CandidatePipelineTableItem from './CandidatePipelineTableItem.vue';
import Pagination from '@/components/Navigations/Pagination';

import { errorService } from '../../../services/errorService';

import ErrorList from '@/components/common/errorsList';

export default {
  components: {
    Pagination,
    AddBtn,
    CustomMainModal,
    AddToPipelineBtnModal,
    Search,
    ErrorList,
    CandidatePipelineTableItem,
  },
  data: () => ({
    showModal: false,
    rating: 1,
    isLoading: false,
    pipelineId: '',
    pipelineForUpdate: {},
    pipelineForDeleteId: '',
    pipelineForSubmit: {},
    selectedDocuments: [],
    isSubmitted: false,
    currentPage: 1,
    pageCount: 10,
  }),
  methods: {
    ...mapActions(['retrieveCandidatePipelines', 'retrieveSourcesList']),

    reloadPipelineList({ currentPage, count }) {
      // console.log('rpl: ', { currentPage, count });

      this.retrieveCandidatePipelines({
        candidate_id: this.$route.params.candidate_id,
        search_word: '',
        count: count,
        page: currentPage,
      })
        .then(() => {
          this.isLoading = false;
          this.$emit('reload-activity');
        })
        .catch(err => {
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 5000,
          });

          this.isLoading = false;
        });
    },
    doSearch(searchphrase) {
      this.currentPage = 1;

      if (searchphrase.length >= 3) {
        this.isLoading = true;

        this.retrieveCandidatePipelines({
          candidate_id: this.$route.params.candidate_id,
          search_word: searchphrase,
          count: this.pageCount,
          page: this.currentPage,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(err => {
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 5000,
            });
            this.isLoading = false;
          });
      }

      if (searchphrase === '') {
        this.retrieveCandidatePipelines({
          candidate_id: this.$route.params.candidate_id,
          search_word: '',
          count: this.pageCount,
          page: this.currentPage,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(err => {
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 5000,
            });
            this.isLoading = false;
          });
      }
    },
    /* Pagination */
    nextPage() {
      if (this.currentPage >= 1 && this.currentPage < this.getTotalPages) {
        // this.isLoading = true;
        this.currentPage++;

        this.$emit('reload-pipeline', { page: this.currentPage, count: this.pageCount });
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        //   this.isLoading = true;
        --this.currentPage;

        this.$emit('reload-pipeline', { page: this.currentPage, count: this.pageCount });
      } else {
        this.currentPage = 1;
      }
    },
    setToFirstPage() {
      //  this.isLoading = true;
      this.currentPage = 1;
      this.$emit('reload-pipeline', { page: this.currentPage, count: this.pageCount });
    },
    setToLastPage(lastPage) {
      //  this.isLoading = true;
      this.currentPage = lastPage;
      this.$emit('reload-pipeline', { page: this.currentPage, count: this.pageCount });
    },
    setPageBynumber(pageNumber) {
      if (pageNumber > this.getTotalPages || pageNumber < 1) return;
      this.currentPage = Number(pageNumber);

      this.$emit('reload-pipeline', { page: this.currentPage, count: this.pageCount });
    },
    keymonitor(event) {
      // who caused it? "event.target.id"
      // console.log('keyup from id: ' + event.target.id);

      // what was pressed?
      let keyMessage = event.key || String.fromCharCode(event.keyCode);

      /* if (event.shiftKey) {
        keyMessage += 'Shift+';
      } */

      if (keyMessage == 'ArrowRight') {
        this.nextPage();
      }

      if (keyMessage == 'ArrowLeft') {
        this.previousPage();
      }
    },
    /* End Pagination */
  },
  computed: {
    ...mapGetters([
      'getUserProfile',
      'getRating',
      'getCandidateById',
      'getCurrentPage',
      'getTotalPages',
      'getCandidateDocuments',
      'getCandidatePipelines',
    ]),
  },
  mounted() {
    /* this.retrieveCandidatePipelines({
      candidate_id: this.$route.params.candidate_id,
      search_word: '',
      count: this.pageCount,
      page: this.currentPage,
    })
      .then(() => {
        this.isLoading = false;
      })
      .catch((err) => {
        this.$toasted.error(errorService(err), {
          theme: 'bubble',
          icon: 'fa-times-circle',
          position: 'bottom-right',
          duration: 5000,
        });
        this.isLoading = false;
      }) */
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.jobs-controls {
  .input-group {
    i {
      color: $color-table-location;
      position: absolute;
      pointer-events: none;
      top: 8px;
      right: 12px;
      font-size: 21px;
      z-index: 99;
    }
    .form-control {
      border-radius: 0.25rem !important;
    }
  }
}

@media only screen and (max-width: 768px) {
  #stages-dropdown {
    flex: 1;
    .dropdown-toggle {
      width: 100%;
    }
  }
  .btn-success {
    display: none !important;
  }
}

@media only screen and (max-width: 576px) {
  .bottom-controls,
  .no-mobile {
    display: none !important;
  }
  .jobs-controls {
    .d-flex {
      display: block !important;
      .input-group {
        width: 100% !important;
      }
    }
    .dropup,
    .dropright,
    .dropdown,
    .dropleft {
      background: red;
    }
  }

  .list-unstyled.mobile-pipeline {
    font-family: $font-family-sans-lato;
    li {
      position: relative;
      padding: 6px 22px 6px 22px;
      border-bottom: 1px solid #ddd;
      a.username {
        display: block;
        font-size: 16px;
        font-weight: 700;
        text-decoration: none;
      }

      a.toggle-collapse {
        color: #666;
        position: absolute;
        top: 50%;
        right: -2px;
        transform: translate(0, -50%);
      }

      .d-flex:first-of-type {
        span {
          font-size: 14px;
          &:first-of-type {
            color: $color-orange;
            margin-right: auto;
          }

          &:nth-of-type(2) {
            color: #5f5f5f;
          }
        }
      }

      .d-flex:nth-of-type(2) {
        span {
          font-size: 14px;

          &:first-of-type {
            color: #5f5f5f;
            margin-right: auto;
          }

          &:nth-of-type(2) {
            color: #5f5f5f;
            position: relative;
            .status {
              border-radius: 50%;
              display: inline-block;
              width: 11px;
              height: 11px;
              background: red;
              margin: 0px 5px 0 0;
              &.employment {
                background: $color-status-active;
              }
              &.self-employment {
                background: $color-base-blue;
              }
              &.mixed-orange {
                background: $color-orange;
              }
            }
          }
        }
      }
      img {
        position: absolute;
        top: 8px;
        right: 22px;
      }
    }
  }
}

.dropdown {
  button {
    box-shadow: 0px 2px 3px #0000000d;
    background: url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='14' height='14' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='grey'/></g></svg>")
      no-repeat !important;
    background-position: right 3px top 50% !important;
    margin-right: 3px !important;
    -webkit-appearance: none;
    -moz-appearance: none;

    &::after {
      display: none;
      /*  -webkit-appearance: none;
      -moz-appearance: none; */
    }
    color: #4d4f5c;
  }

  .dropdown-menu {
    padding: 8px 12px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
    ul > li:not(:last-child) {
      margin-bottom: 1rem;
    }

    width: 250px;
    margin-top: 5px;

    .custom-control {
      margin-bottom: 0;
    }
  }

  button {
    background-color: #fff;
    border: 1px solid #d7dae2;
    border-radius: 4px;
    width: 250px;
    text-align: left;
  }
}

@media only screen and (max-width: 576px) {
  .dropdown.ml-3 {
    margin-left: 0 !important;
    .btn {
      width: 100%;
      margin: 12px 0;
    }
  }
}
</style>
